import {
	useDeleteAssignmentMutation,
	useGetAssignmentsQuery,
} from "../../../features/assignment/assignmentApi";
import { Link } from "react-router-dom";
import { shortStr } from "../../../utils/commonUtility";
import Loading from "../../../components/ui/Loading";
import Error from "../../../components/ui/Error";
import EmptyResult from "../../../components/ui/EmptyResult";
import Table from "../../ui/Table";
import TableRow from "../../ui/TableRow";
import MessageToast from "../../ui/MessageToast";

export default function Assignments() {
	const {
		data: assignments,
		isLoading: isGetAssignmentLoading,
		isError: isGetAssignmentError,
	} = useGetAssignmentsQuery() || {};

	const [
		deleteAssignment,
		{ isError: isAssignmentDeleteError, isSuccess: isAssignmentDeleteSuccess },
	] = useDeleteAssignmentMutation() || [];

	const handleDeleteAssignment = (assignmentId) => {
		deleteAssignment(assignmentId);
	};

	// Decide what to render
	let content = null;
	if (isGetAssignmentLoading) {
		content = <Loading />;
	} else if (!isGetAssignmentLoading && isGetAssignmentError) {
		content = <Error message="There was an error!" />;
	} else if (
		!isGetAssignmentLoading &&
		!isGetAssignmentError &&
		assignments?.length === 0
	) {
		content = <EmptyResult message="No assignments found, please add" />;
	} else if (
		!isGetAssignmentLoading &&
		!isGetAssignmentError &&
		assignments?.length > 0
	) {
		const headers = ["Title", "Video Title", "Mark", "Action"];
		content = (
			<Table headers={headers}>
				{assignments.map((assignment) => {
					console.log("ass:", assignment);
					const shortAssignmentTitle = shortStr(assignment.title, 70);
					const shortVideoTitle = shortStr(assignment.video_title, 80);

					return (
						<TableRow
							key={assignment.id}
							data={[
								shortAssignmentTitle,
								shortVideoTitle,
								assignment.totalMark,
							]}
							editRoute={`/admin/assignments/edit/${assignment.id}`}
							deleteCallBack={handleDeleteAssignment}
							dataId={assignment.id}
						/>
					);
				})}
			</Table>
		);
	}

	return (
		<section className="py-6 bg-primary">
			<div className="mx-auto max-w-full px-5 lg:px-20">
				<div className="px-3 py-20 bg-opacity-10">
					<div className="w-full flex">
						<Link
							to="/admin/assignments/add"
							className="btn ml-auto"
						>
							Add Assignment
						</Link>
					</div>
					{content}
				</div>
			</div>
			
			{isAssignmentDeleteSuccess && <MessageToast message="Assignment delete success" />}
			{isAssignmentDeleteError && <MessageToast message="Assignment delete failed!" type="error" />}
		</section>
	);
}
